((Buy2, $) => {
  'use strict';

  let $columnContainer;
  let $swatch;
  let $sleeve;
  let $sleeveImg;
  let collectionHandle;

  const cacheDom = () => {
    $columnContainer = $('.buy-2-columns');
    $swatch = $columnContainer.find('.swatch');
    $sleeve = $columnContainer.find('.sleeve');
    $sleeveImg = $sleeve.find('img');
  };

  const variableSetup = (options) => {
    collectionHandle = options.collectionHandle;
  };

  const variantAddToCart = (variantArray, $this) => {
    if ($.inArray(undefined, variantArray) !== -1 || $.inArray('', variantArray) !== -1) {
      alert('Select 3 sleeves to add to cart.');
      variantArray = [];
    } else {
      $this.text('ADDING');
      variantArray.forEach((id) => {
        window.CartJS.addItem(id, 1);
      });
      variantArray = [];

      if (window.Cookies.get('BVAUpsell')) {
        window.InlineCart.triggerInlineCart();
        window.Scroll.lock();
      } else {
        const title = $this.attr('data-product-upsell-title');
        const $upsellTitle = $('.js-product-upsell-title');

        if (title) {
          $upsellTitle.text(title);
        } else {
          $upsellTitle.text(window.ProductUpsell.defaultTitle);
        }

        ProductUpsell.open(collectionHandle);
      }
    }
    return variantArray;
  };

  const bindUIActions = () => {
    let variantArray = [];

    // Desktop functionality
    $swatch.on('click', function switchActiveSwatch() {
      const $this = $(this);
      const activeClass = 'active';

      $this.parent().find(`.${activeClass}`).removeClass(activeClass);
      $this.addClass(activeClass);
    });

    $sleeveImg.on('click', function selectSleeve() {
      const $this = $(this);
      const $currentOrifice = $this.closest('.sleeve');
      const $activeOrifice = $this.closest('.sleeves').siblings('.sleeve-orifice-swatch').find('.active');
      const activeClass = 'sleeve-active';

      let newOrificeImg;
      let orificeVariant;

      if ($activeOrifice.hasClass('orifice-vag')) {
        newOrificeImg = $this.data('vag');
        orificeVariant = $this.data('vag-id');
      } else if ($activeOrifice.hasClass('orifice-butt')) {
        newOrificeImg = $this.data('butt');
        orificeVariant = $this.data('butt-id');
      } else if ($activeOrifice.hasClass('orifice-cheeks')) {
        newOrificeImg = $this.data('cheeks');
        orificeVariant = $this.data('cheeks-id');
      } else if ($activeOrifice.hasClass('orifice-mouth')) {
        newOrificeImg = $this.data('mouth');
        orificeVariant = $this.data('mouth-id');
      }

      if (newOrificeImg && orificeVariant) {
        $this.closest('.sleeves').siblings('.sleeve-image').find('img').attr('src', newOrificeImg);
        $this.closest('.sleeves').siblings('.sleeve-image').find('img').attr('data-variant-id', orificeVariant);
        $currentOrifice.siblings().removeClass(activeClass);
        $currentOrifice.addClass(activeClass);
      } else {
        alert('Select an orifice to continue.');
      }
    });

    $('.add-sleeves').on('click', function addSleeve() {
      $('.sleeve-image img').each(function addVariantToArray() {
        variantArray.push($(this).data('variant-id'));
      });

      variantArray = variantAddToCart(variantArray, $(this));

      $(document).on('cart.requestComplete', () => {
        $('.add-sleeves').text('ADD TO CART');
      });
    });

    // Mobile Functionality
    $('.mobile-swatch').on('click', function switchActiveSwatchMobile() {
      const $this = $(this);
      const swatchSectionIndex = $this.closest('.mobile-sleeve-section').attr('id');

      if ($this.parent().children().hasClass('active')) {
        $this.parent().find('.active').removeClass('active');
        $this.parent().siblings('.mobile-sleeves')
          .find('.mobile-sleeve')
          .removeClass('fade')
          .slideDown('fast');
        $this.parent().siblings('.mobile-sleeves').find('.selected').removeClass('selected');
        $(`.mobile-sleeve-image-${swatchSectionIndex} img`).attr('data-variant-id', '');
      } else {
        $this.addClass('active');
      }
    });

    $('.mobile-sleeve').on('click', function switchActiveSleeveMobile() {
      const $this = $(this);
      const mobileOrifice = $this.closest('.mobile-sleeve-section').find('.sleeve-orifice-swatch').children();
      const mobileOrificeActive = $this.closest('.mobile-sleeve-section').find('.sleeve-orifice-swatch').find('.active');
      const mobileOrificeSection = $this.closest('.mobile-sleeve-section').attr('id');

      let mobileImgURL;
      let mobileVariantId;

      if (!mobileOrifice.hasClass('active')) {
        alert('Select an orifice to continue.');
      } else {
        $('.mobile-sleeve-images').css('visibility', 'visible');

        if (mobileOrificeActive.hasClass('orifice-vag')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('vag');
          mobileVariantId = $this.find('.sleeve-row-image').data('vag-id');
        } else if (mobileOrificeActive.hasClass('orifice-butt')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('butt');
          mobileVariantId = $this.find('.sleeve-row-image').data('butt-id');
        } else if (mobileOrificeActive.hasClass('orifice-mouth')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('mouth');
          mobileVariantId = $this.find('.sleeve-row-image').data('mouth-id');
        } else if (mobileOrificeActive.hasClass('orifice-cheeks')) {
          mobileImgURL = $this.find('.sleeve-row-image').data('cheeks');
          mobileVariantId = $this.find('.sleeve-row-image').data('cheeks-id');
        }

        $this.closest('.buy-2-grid-mobile')
          .find('.mobile-sleeve-images')
          .find(`.mobile-sleeve-image-${mobileOrificeSection}`)
          .find('img')
          .css('visibility', 'visible')
          .attr('src', mobileImgURL)
          .attr('data-variant-id', mobileVariantId);
      }
    });

    $('.sleeve-table-row').on('click', function selectSleeveMobile() {
      const $this = $(this);

      if ($this.hasClass('mobile-sleeve')) {
        if ($this.closest('.mobile-sleeve-section').find('.sleeve-orifice-swatch').children().hasClass('active')) {
          $this.siblings().slideToggle('fast').toggleClass('fade');
          if (!$this.hasClass('selected')) {
            $this.addClass('selected');
          } else {
            $this.removeClass('selected');
            const mobileSleeveSection = $(this).closest('.mobile-sleeve-section').attr('id');
            $this.closest('.buy-2-grid-mobile')
              .find('.mobile-sleeve-images')
              .find(`.mobile-sleeve-image-${mobileSleeveSection}`)
              .find('img')
              .attr('data-variant-id', '');
          }
        }
      } else {
        $this.siblings().slideToggle('fast').toggleClass('fade');
      }
    });

    $('.add-sleeves-mobile').on('click', function addSleeveMobile() {
      $('.mobile-sleeve-image img').each(function addVariantToArrayMobile() {
        variantArray.push($(this).data('variant-id'));
      });

      variantArray = variantAddToCart(variantArray, $(this));

      $(document).on('cart.requestComplete', () => {
        $('.add-sleeves-mobile').text('ADD TO CART');
      });
    });
  };

  const init = (options) => {
    cacheDom();
    variableSetup(options);
    bindUIActions();
  };

  Buy2.init = init;
})(window.Buy2 = window.Buy2 || {}, jQuery);
